export enum UserActionTypes {
  REQUEST_USER_PROFILE = '@user/REQUEST_USER_PROFILE',
  REQUEST_USER_PROFILE_SUCCESS = '@user/REQUEST_USER_PROFILE_SUCCESS',
  REQUEST_USER_PROFILE_ERROR = '@user/REQUEST_USER_PROFILE_ERROR',
  EMAIL_USER_FORGOT_PASSWORD = '@user/EMAIL_USER_FORGOT_PASSWORD',
}
